import { SlackChannels } from '../../pure-js/enums/SlackChannels.js'
import { sendToGoogleChat } from '../../pure-js/libs/GoogleChatHelper.js'
import config from '../src/Config.js'

/**
 * Send a message to Google Chat via webhook.
 * Wraps the shared sendToGoogleChat with this environment's config.
 *
 * @deprecated Google Chat notifications are disabled. Use Slack via notify() instead.
 */
export const googleChat = (text: string, channel: SlackChannels): Promise<void> =>
  sendToGoogleChat(text, channel, config.enableGoogleChat)
